export default __webpack_public_path__ + "static/media/CW__2973.87f037c6.jpg";